import { render, staticRenderFns } from "./LastOrdersItem.vue?vue&type=template&id=d6632d26&"
import script from "./LastOrdersItem.vue?vue&type=script&lang=js&"
export * from "./LastOrdersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6632d26')) {
      api.createRecord('d6632d26', component.options)
    } else {
      api.reload('d6632d26', component.options)
    }
    module.hot.accept("./LastOrdersItem.vue?vue&type=template&id=d6632d26&", function () {
      api.rerender('d6632d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/LastOrdersItem.vue"
export default component.exports